const ingredientsList = document.querySelector('.ingredients-list');
const ingredientsListItemsContainer = ingredientsList.querySelector('.ingredients-list__items');
const ingredientsListItems = ingredientsList.querySelectorAll('.ingredients-list__items .item');
const dotsNumber = Math.round(ingredientsListItems.length/2);
const ingredientsListDotsContainer = ingredientsList.querySelector('.dots');
const ingredientsListControlsbtns = ingredientsList.querySelectorAll('.controls .btn');

/* DOTS */

function updateIngredientsListDots() {

    for(let i=0;i<dotsNumber;i++){
        const newDot = document.createElement('div');
        newDot.id = i+1;
        newDot.classList.add('dot');
        if(i==0){
            newDot.classList.add('active');
        }
        newDot.innerHTML = '<div class="round"></div>';
        ingredientsListDotsContainer.appendChild(newDot);
    }
}
updateIngredientsListDots();

/* CONTROLS */

const ingredientsListDots = ingredientsList.querySelectorAll('.dots .dot');
let ingredientsListSlide = 1;

function updateIngredientsListSlide(){

    // UPDATE INGREDIENTS
    const slideWidth = (ingredientsListItems[0].clientWidth*2)*(ingredientsListSlide-1);
    ingredientsListItemsContainer.style = `transform: translateX(-${slideWidth}px)`;

    // UPDATE DOT
    for(let i=0;i<ingredientsListDots.length;i++){
        if(ingredientsListDots[i].id == ingredientsListSlide){
            ingredientsListDots[i].classList.add('active');
        }else{
            ingredientsListDots[i].classList.remove('active');
        }
    }

}

ingredientsListControlsbtns.forEach(button => {
    button.addEventListener('click', () => {
        if(button.id == 'left'){
            if(ingredientsListSlide != 1){
                ingredientsListSlide--;
            }else{
                ingredientsListSlide=dotsNumber;
            }
        }else if(button.id == 'right'){
            if(ingredientsListSlide != dotsNumber){
                ingredientsListSlide++;
            }else{
                ingredientsListSlide=1;
            }
        }
        updateIngredientsListSlide();
    })
})